import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class CustomersContracts extends CommonCRUD {}

export default CustomersContracts;
